import { Pipe, PipeTransform } from '@angular/core';
import { Column } from '../models/column';
import { DatePipe, DecimalPipe, CurrencyPipe } from '@angular/common';
import { HelperService } from '../Services/Helper.Service';

@Pipe({ name: 'format' })
export class FormatPipe implements PipeTransform {
    constructor(private datePipe: DatePipe, private decimalPipe: DecimalPipe, private currencyPipe: CurrencyPipe, private helper: HelperService) { }
    transform(value: any, col: Column): any {
        if (col.dataType === 'date') {
            if (value !== null && value !== undefined) {
                if (col.dateFormat === undefined || col.dateFormat === null) {
                    return (new Date(value)).toLocaleDateString();
                } else {
                    return this.datePipe.transform(new Date(value), col.dateFormat.toString());
                }
            }
            return value;
        } else if (col.dataType === 'number') {
            let rValue = value;
            if (value !== null && value !== undefined) {
                if (col.currencySymbol === undefined || col.currencySymbol === null || col.currencySymbol === '') {
                    if (col.decimalPlaces === undefined || col.decimalPlaces === null) {
                        rValue = value.toLocaleString();
                    } else {
                        rValue = this.decimalPipe.transform(value, '1.0-' + col.decimalPlaces.toString());
                    }
                } else {
                    if (col.decimalPlaces === undefined || col.decimalPlaces === null) {
                        rValue = this.currencyPipe.transform(value, col.currencySymbol.toString(), 'symbol', '1.0-9');
                    } else {
                        rValue = this.currencyPipe.transform(value, col.currencySymbol.toString(), 'symbol', '1.0-' + col.decimalPlaces.toString());
                    }
                }
                if (col.thousandSepartor !== undefined && col.thousandSepartor !== null && col.thousandSepartor !== ',') {
                    rValue = rValue.replace(/,/g, col.thousandSepartor);
                }
            }
            return rValue;
        } else if (col.dataType === 'month') {
            return this.helper.getMonthName(value);
        } else {
            return value;
        }
    }

    transformStr(value: any, dataType: string): any {
        if (dataType === 'date') {
            return (new Date(value)).toLocaleDateString();
        } else {
            return value;
        }
    }
}
